import { useEffect, useContext, useState } from "react";
import axios from "axios";
import classes from "../Pages.module.css";
import { Skeleton, Row, Col, message, Tooltip, Modal, Button } from "antd";
// import { Form, Input } from "antd";
import { AiFillDelete } from "react-icons/ai";
import { FaPenAlt } from "react-icons/fa";
import DataContext from "../../../Context/dataContext";
import EmployeeTable from "../EmployeeTable/EmployeeTable";
import FormRenderer from "./FormRenderer";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { notification } from "antd";
import { canPerformActionOnDay, getDayPermissionMessage } from '../../../utils/checkDayPermission';

const Misc = (props) => {
  console.log(props.data, "uom");
  // const { id1 } = useParams();
  const employeeData = useContext(DataContext);
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  // const [title, setTitle] = useState("");
  const [rows, setRows] = useState(null);
  const [form, setForm] = useState(null);
  const [urows, setURows] = useState(true);
  const [vrows, setVRows] = useState(true);
  const [uform, setUForm] = useState(null);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [id, setID] = useState("");
  // const [identifier, setIdentifier] = useState("");
  const [allData, setAllData] = useState({
    cityHeader: [
      {
        city_code:null,
        city_name: null,
        site_desc: null,
        state_code: null,
        add1: null,
        ph1: null,
        pan_no: null,
        email: null,
        gst_no: null,
        cin_no: null,
        bank_name: null,
        ifsc_cd: null,
        start_date: null

      },
    ],
  });
  const [allData1, setAllData1] = useState({
    cityHeader: [
      {
        city_code:null,
        city_name: null,
        site_desc: null,
        state_code: null,
        add1: null,
        ph1: null,
        pan_no: null,
        email: null,
        pin_code:null,
        gst_no: null,
        cin_no: null,
        service_tax_no: null,
        bank_name: null,
        ifsc_cd: null,
        start_date: null
      },
    ],
  });
  // const [mata, setMata] = useState({
  //   cityHeader: [
  //     {
  //       city_name: null,
  //       state_code: null,
  //       distt: null,
  //       country_code: null,
  //     },
  //   ],
  // });
  const [ad, setAD] = useState(null);
  // Get permission flags for the current form including day-based checks
  const getPermissionFlags = () => {
    // Check if user is admin (role_cd = 1)
    const roleCd = localStorage.getItem("roleCd");
    if (roleCd === "1") {
      return {
        canAdd: true,
        canModify: true,
        canDelete: true,
        canQuery: true,
        messages: {
          add: "",
          modify: "",
          delete: "",
          query: ""
        }
      };
    }

    const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const dayIdx = new Date().getDay();

    // Debug logging for permission data
    console.log('Permission Data:', {
      hasPermissionData: !!employeeData?.permission?.permission,
      isArray: Array.isArray(employeeData.permission?.permission),
      rawData: employeeData?.permission?.permission,
      currentDay: days[dayIdx]
    });

    if (!employeeData?.permission?.permission || 
        !Array.isArray(employeeData.permission?.permission)) {
      return {
        canAdd: false,
        canModify: false,
        canDelete: false,
        canQuery: false,
        messages: {
          add: "No permissions configured",
          modify: "No permissions configured",
          delete: "No permissions configured",
          query: "No permissions configured"
        }
      };
    }
    
    // Debug the form search
    console.log('Searching for form permissions:', {
      searchingFor: 'City Master',
      availableForms: employeeData.permission.permission.map(p => p.form_name)
    });
    
    const formPermission = employeeData.permission.permission.find(p => 
      p.form_name.trim() === 'City Master'
    );
    
    // Enhanced debug logging for form permission
    console.log('Form Permission Details:', {
      found: !!formPermission,
      formName: formPermission?.form_name,
      searchingFor: 'City Master',
      allFormNames: employeeData.permission.permission.map(p => ({ 
        name: p.form_name,
        exactMatch: p.form_name === 'City Master',
        trimmedMatch: p.form_name.trim() === 'City Master'
      })),
      dayFlags: formPermission ? Object.keys(formPermission).filter(k => k.match(/^[amdq]_(all_days|monday|tuesday|wednesday|thursday|friday|saturday|sunday)$/)) : [],
      generalFlags: formPermission ? {
        l_add: formPermission.l_add,
        l_modify: formPermission.l_modify,
        l_delete: formPermission.l_delete,
        l_query: formPermission.l_query
      } : null,
      dayPermissions: formPermission ? {
        add: { all_days: formPermission.a_all_days, today: formPermission[`a_${days[dayIdx]}`] },
        modify: { all_days: formPermission.m_all_days, today: formPermission[`m_${days[dayIdx]}`] },
        delete: { all_days: formPermission.d_all_days, today: formPermission[`d_${days[dayIdx]}`] },
        query: { all_days: formPermission.q_all_days, today: formPermission[`q_${days[dayIdx]}`] }
      } : null
    });
    
    if (!formPermission) {
      return {
        canAdd: false,
        canModify: false,
        canDelete: false,
        canQuery: false,
        messages: {
          add: "No form permissions found",
          modify: "No form permissions found",
          delete: "No form permissions found",
          query: "No form permissions found"
        }
      };
    }

    // Check both general permissions and day-based permissions
    const canAdd = formPermission.l_add === 'Y' && canPerformActionOnDay(formPermission, 'a');
    const canModify = formPermission.l_modify === 'Y' && canPerformActionOnDay(formPermission, 'm');
    const canDelete = formPermission.l_delete === 'Y' && canPerformActionOnDay(formPermission, 'd');
    const canQuery = formPermission.l_query === 'Y' && canPerformActionOnDay(formPermission, 'q');

    return {
      canAdd,
      canModify,
      canDelete,
      canQuery,
      messages: {
        add: formPermission.l_add !== 'Y' ? "You don't have permission to add items" : getDayPermissionMessage(formPermission, 'a'),
        modify: formPermission.l_modify !== 'Y' ? "You don't have permission to modify items" : getDayPermissionMessage(formPermission, 'm'),
        delete: formPermission.l_delete !== 'Y' ? "You don't have permission to delete items" : getDayPermissionMessage(formPermission, 'd'),
        query: formPermission.l_query !== 'Y' ? "You don't have permission to view items" : getDayPermissionMessage(formPermission, 'q')
      }
    };
  };

  const { canAdd, canModify, canDelete, canQuery, messages } = getPermissionFlags();
 
  useEffect(() => {
    // setTitle("");
    setForm((form) => {
      const newForm = null;
      return newForm;
    });
    setID("");
    // setIdentifier("");
    setRows(null);
    setColumns([]);
    setLoading(false);
    setAD(null);

    axios
      .get(employeeData.URL + "/api/v1/unit/", {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response);
        console.log(response.data.data.city);


        setColumns((columns) => {
          let newCols = response.data.data.city.fields.map((col) => {
            return {
              name: col.name,
              title: col.name.split("_").join(" ").toLowerCase(),
            };
          });

          const newNewCols = [
            // { name: "E", title: "E" },
            { name: "D", title: "D" },
            { name: "SNO", title: "SNo" },
            ...newCols,
          ];
          return newNewCols;
        });

        setRows((rows) => {
          let newRows = response.data.data.city.rows.map((row, index) => {
            return {
              E: (() => {
                const permissions = getPermissionFlags();
                return permissions.canModify ? (
                <Tooltip placement="bottom" title="Edit" color="#1777C4">
                  <Link
                    to="#"
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                    onClick={(event) =>
                      editHandler(
                        event,
                        index,
                        // response.data.data.tableHeader.row_identifier,
                        row["site_code"],
                        response.data.data.city.rows
                      )
                    }
                  >
                    <FaPenAlt
                      style={{ color: "#1777C4", fontWeight: "bolder" }}
                    />
                  </Link>
                </Tooltip>
              ):(
                <Tooltip placement="bottom" title={permissions.messages.modify} color="#1777C4">
                    <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                      <FaPenAlt
                        style={{ color: "#1777C4", fontWeight: "bolder" }}
                      />
                    </span>
                  </Tooltip>
              );
            })(),
              D: (() => {
                const permissions = getPermissionFlags();
                return permissions.canDelete ? (
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link
                    to="#"
                    style={{ color: "red", fontWeight: "bolder" }}
                    onClick={(event) =>
                      deleteHandler(
                        event,
                        index,
                        response.data.data.city.rows,
                        row["site_code"]
                      )
                    }
                  >
                    <AiFillDelete
                      style={{ color: "red", fontWeight: "bolder" }}
                    />
                  </Link>
                </Tooltip>
              ):(
                <Tooltip placement="bottom" title={permissions.messages.delete} color="red">
                <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                  <AiFillDelete
                    style={{ color: "red", fontWeight: "bolder" }}
                  />
                </span>
              </Tooltip>
              );})(),
              SNO: index + 1,
              ...row,
            };
          });

          return newRows;
        });

        
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(employeeData.URL + "/api/v1/unit/additional-data", {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response);
        setAD((ad) => {
          let newad = response.data.data;
          return {
            ...newad,
          };
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }, [employeeData, canDelete, canQuery]);

  const deleteHandler = (event, index, newrows, code) => {
    const permissions = getPermissionFlags();
    if (!permissions.canDelete) {
      return;
    }
    console.log(code,"city_code");
    console.log(newrows,"newRows_ils tkjcf");
    setLoading(true);
    setRows(null);
  
    axios
      .delete(employeeData.URL + "/api/v1/unit/" + code.toString(), {
        withCredentials: true,
      })
      .then((response) => {
        const { message: backendMessage, isUsed } = response.data;
  
        if (response.data.status === "success") {
          message.success(backendMessage);
        } else {
          message.warning(backendMessage);
        }
  
        let rowvals = newrows;
        if (!isUsed) {
          rowvals = newrows.filter((row) => row["site_code"] !== code);
        }
  
        setRows((rows) => {
          let newDRows = rowvals.map((row, index) => {
            return {
              E: (
                <Tooltip placement="bottom" title="Edit" color="#1777C4">
                  <Link
                    to="#"
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                    onClick={(event) =>
                      editHandler(event, index, row["site_code"])
                    }
                  >
                    <FaPenAlt
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ),
              D: (
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                    <AiFillDelete
                      onClick={(event) =>
                        deleteHandler(event, index, rowvals, row["site_code"])
                      }
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ),
              SNO: index + 1,
              ...row,
            };
          });
          return newDRows;
        });
        setLoading(false);
      })
      .catch((error) => {
        message.error("Failed to delete unit. Please try again.");
        setRows((rows) => {
          let newDRows = newrows.map((row, index) => {
            return {
              E: (
                <Tooltip placement="bottom" title="Edit" color="#1777C4">
                  <Link
                    to="#"
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                    onClick={(event) =>
                      editHandler(event, index, row["site_code"])
                    }
                  >
                    <FaPenAlt
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ),
              D: (
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                    <AiFillDelete
                      onClick={(event) =>
                        deleteHandler(event, index, newrows, row["site_code"])
                      }
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ),
              SNO: index + 1,
              ...row,
            };
          });
          return newDRows;
        });
        setLoading(false);
      });
  };
  

  const editHandler = (event, mainindex, code, newRows) => {
    const permissions = getPermissionFlags();
    if (!permissions.canModify) {
      return;
    }
    console.log("vandna",newRows);
    console.log("Edit button clicked");
    console.log(newRows, "kdkdkdkdkdkdkkd");
    setVRows(false);
    const rowData = newRows[mainindex];
    console.log(rowData,"this is row data in edit handler");
  

    const transformedData = {
      cityHeader: [
        {
         
          state_code: rowData.state_name,
        
      
          city_code: rowData.city_code,
          site_desc: rowData.site_desc,
          add1: rowData.add1,
          ph1: rowData.ph1,
          pan_no: rowData.pan_no,
          email: rowData.email,

          pin_code: rowData.pin_code,
          gst_no: rowData.gst_no,
          cin_no: rowData.cin_no,
          service_tax_no: rowData.service_tax_no,
          bank_name: rowData.bank_name,
          ifsc_cd: rowData.ifsc_cd,
        

        },
      ],
    };

    setAllData1(transformedData);
    setID(code);
    setVisible(true);
  };

  const validateAllData = (allData) => {
    const cityHeaderData = allData.cityHeader[0];
    let formValid = true;

    // Check if any of the required fields in cityHeaderData are null or empty
    if (
    
      !cityHeaderData.state_code ||
      !cityHeaderData.city_code ||
    
      !cityHeaderData.add1 ||
      !cityHeaderData.ph1 ||
      !cityHeaderData.pan_no ||
      !cityHeaderData.email ||
      !cityHeaderData.gst_no ||
      !cityHeaderData.cin_no ||
      !cityHeaderData.service_tax_no ||
      !cityHeaderData.bank_name ||
      !cityHeaderData.ifsc_cd ||

      !cityHeaderData.pin_code

    
    ) {
      notification.error({
        message: "Missing Required Fields",
        description:
          "Please fill in all the required fields in the Unit Form.",
        duration: 5,
      });
      formValid = false;
    }

    return formValid;
  };

  const handleSubmit = (event) => {
    console.log(allData);
    const postData = {
      ...allData,
    };

    event.preventDefault(); // Prevent default form submission

    if (!validateAllData(allData)) {
      return;
    }

    console.log(postData);
    setLoading(true);
    axios
      .post(employeeData.URL + "/api/v1/unit/create-city", postData, {
        withCredentials: true,
        credentials: "include",
      })
      .then((response) => {
        console.log(response);
        // Check the response for success
        if (response.data.status === "success") {
          // Display success message
          message.success({
            content: "Record Added Successfully!!!!",
            className: "custom-class",
            style: {
              marginTop: "20vh",
            },
          });
        } else {
          // Display error message for duplicate data
          message.error({
            content: response.data.message || "Error adding record.",
            className: "custom-class",
            style: {
              marginTop: "20vh",
            },
          });
        }

        setRows(null);
        setLoading(false);

        setAllData((prevData) => ({
          ...prevData,
          cityHeader: [
            {  state_code: "",  city_code: "" ,
              site_desc: "",
              add1: "",
              ph1: "",
              pan_no: "",
              email: "",
              pin_code:"",
              gst_no: "",
              cin_no: "",
              service_tax_no: "",
              bank_name: "",
              ifsc_cd: "",
             
            }
          ],
        }));

        axios
          .get(employeeData.URL + "/api/v1/unit/", {
            withCredentials: true,
          })
          .then((response) => {
            console.log(response.data.data.city);
            setRows((rows) => {
              let newRows = response.data.data.city.rows.map((row, index) => {
                return {
                  E: (() => {
                    const permissions = getPermissionFlags();
                    return permissions.canModify ? (
                    <Tooltip placement="bottom" title="Edit" color="#1777C4">
                      <Link
                        to="#"
                        style={{ color: "#1777C4", fontWeight: "bolder" }}
                        onClick={(event) =>
                          editHandler(
                            event,
                            index,
                            //   response.data.data.tableHeader.row_identifier,
                            row["site_code"],
                            response.data.data.city.rows
                            //   response.data.data.tableHeader.master_fields
                          )
                        }
                      >
                        <FaPenAlt
                          style={{ color: "#1777C4", fontWeight: "bolder" }}
                        />
                      </Link>
                    </Tooltip>
                  ):(
                    <Tooltip placement="bottom" title={permissions.messages.modify} color="#1777C4">
                          <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                            <FaPenAlt
                              style={{ color: "#1777C4", fontWeight: "bolder" }}
                            />
                          </span>
                        </Tooltip>
                  );
                })(),
                  D: (() => {
                    const permissions = getPermissionFlags();
                    return permissions.canDelete ? (
                    <Tooltip placement="bottom" title="Delete" color="red">
                      <Link
                        to="#"
                        style={{ color: "red", fontWeight: "bolder" }}
                        onClick={(event) =>
                          deleteHandler(
                            event,
                            //   response.data.data.tableHeader.row_identifier,
                            row["site_code"]
                          )
                        }
                      >
                        <AiFillDelete
                          style={{ color: "red", fontWeight: "bolder" }}
                        />
                      </Link>
                    </Tooltip>
                  ):(
                    <Tooltip placement="bottom" title={permissions.messages.delete} color="red">
                          <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                            <AiFillDelete
                              style={{ color: "red", fontWeight: "bolder" }}
                            />
                          </span>
                        </Tooltip>
                  );
                })(),
                  SNO: index + 1,
                  ...row,
                };
              });
              return newRows;
            });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        setLoading(false);

        message.error({
          content: "please fill all feild!!!!",
          className: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
      });
  };

  const handleOk = () => {
    // setConfirmLoading(true);
    console.log(allData1);
    const postData = {
      ...allData1,
    };

    console.log(postData);

    axios
      .patch(employeeData.URL + "/api/v1/unit/" + id.toString(), postData, {
        withCredentials: true,
        credentials: "include",
      })
      .then((response) => {
        console.log(response);
        setConfirmLoading(false);
        setVisible(false);

        message.success({
          content: "Record update Successfully!!!!",
          className: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        setRows(null);
        setLoading(false);
        setID("");
        // setIdentifier("");

        // setAllData1({
        //   ...allData1,
        //   uomHeader: [{ uom: (element.value = "") }],
        // });
        // setForm((form) => {
        //   const newForm = [...form];
        //   newForm.forEach((element) => (element.value = ""));

        //   return newForm;
        // });

        axios
          .get(employeeData.URL + "/api/v1/unit/", {
            withCredentials: true,
          })
          .then((response) => {
            setRows((rows) => {
              let newRows = response.data.data.city.rows.map((row, index) => {
                return {
                  E: (
                    <Tooltip placement="bottom" title="Edit" >
                      <Link
                        to="#"
                        style={{ color: "#1777C4" }}
                        onClick={(event) =>
                          editHandler(
                            event,
                            index,
                            //   response.data.data.tableHeader.row_identifier,
                            row["site_code"],
                            response.data.data.city.rows
                          )
                        }
                      >
                        <FaPenAlt
                          // style={{ color: "#1777C4", fontWeight: "bolder" }}
                        />
                      </Link>
                    </Tooltip>
                  ),
                  D: (
                    <Tooltip placement="bottom" title="Delete" color="red">
                      <Link
                        to="#"
                        style={{ color: "red", fontWeight: "bolder" }}
                        onClick={(event) =>
                          deleteHandler(
                            event,
                            //   response.data.data.tableHeader.row_identifier,
                            row["site_code"]
                          )
                        }
                      >
                        <AiFillDelete
                          style={{ color: "red", fontWeight: "bolder" }}
                        />
                      </Link>
                    </Tooltip>
                  ),
                  SNO: index + 1,
                  ...row,
                };
              });
              return newRows;
            });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        setLoading(false);
        setConfirmLoading(false);
        message.error({
          content: "Some Error Occurred!!!!",
          className: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
      });
  };

  const handleCancel = () => {
    
   
    setVisible(false);
    setConfirmLoading(false);
    axios
      .get(employeeData.URL + "/api/v1/unit/", {
        withCredentials: true,
      })
      .then((response) => {
        setLoading(false);

        // let inputTypes = response.data.data.tableHeader.input_type.split(", ");

        let newRows = response.data.data.city.rows.map((row, index) => {
          return {
            E: (
              <Tooltip placement="bottom" title="Edit" >
                <Link
                  to="#"
                  style={{ color: "#1777C4", fontWeight: "bolder" }}
                  onClick={(event) =>{
                    const permissions = getPermissionFlags();
                   if(permissions.canModify){
                    editHandler(
                      event,
                      index,

                      row["site_code"],
                      response.data.data.uom.rows
                    );
                  }
                }}
                >
                  <FaPenAlt
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                  />
                </Link>
              </Tooltip>
            ),
            D: (
              <Tooltip placement="bottom" title="Delete" color="red">
                <Link
                  to="#"
                  style={{ color: "red", fontWeight: "bolder" }}
                  onClick={(event) =>{
                    const permissions = getPermissionFlags();
                    if (permissions.canDelete) {
                    deleteHandler(
                      event,

                      row["site_code"]
                    );
                  }
                }}
                >
                  <AiFillDelete
                    style={{ color: "red", fontWeight: "bolder" }}
                  />
                </Link>
              </Tooltip>
            ),
            SNO: index + 1,
            ...row,
          };
        });
        setRows(newRows);
        setLoading(false);
      });

    // setAllData1({
    //   ...allData1,
    //   uomHeader: [{ uom: (element.value = "") }],
    // });
  };

  return (
    <>
      <Modal
        title="Edit Record"
        visible={visible}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={confirmLoading}
            onClick={handleOk}
          >
            Submit
          </Button>,
        ]}
      >
        {/* <Form
          onFinish={handleOk}
          //   initialValues={{ uom: allData.uomHeader[0].uom }} // Set initial value for uom field
          defaultValue=""
        >
          <Form.Item
            label="Unit Of Measurement"
            name="uom"
            // rules={[
            //   { required: true, message: "Please enter Measure Of Unit!" },
            // ]}
          >
            <Input
              placeholder="Enter Measure Of Unit"
              onChange={(e) => {
                setMata((prevData) => ({
                  ...prevData,
                  uomHeader: [{ uom: e.target.value }],
                }));
              }}
            />
          </Form.Item>
        </Form> */}
        {ad ? (
          <FormRenderer
            loading={loading}
            form={uform}
            setForm={setUForm}
            handleSubmit={handleOk}
            save={false}
            setData={setAllData1}
            data={allData1.cityHeader[0]}
            setURows={setURows}
            urows={urows}
            vrows={vrows}
            ad={ad}
          />
        ) : (
          <p>Loading...</p> // Or any other fallback UI
        )}
      </Modal>
      <Row className={classes["Row"]}>
        <Col md={14}>
          <p className={classes["Title"]}>Unit Master</p>
        </Col>
        <Col className={classes["Col"]} md={10}></Col>
      </Row>
      <p></p>

      {ad && getPermissionFlags().canAdd ? (
        <FormRenderer
          loading={loading}
          form={form}
          setForm={setForm}
          handleSubmit={handleSubmit}
          save={true}
          setData={setAllData}
          data={allData.cityHeader[0]}
          urows={urows}
          vrows={vrows}
          ad={ad}
        />
      ) : (
        <p>{!ad ? "Loading..." : "You don't have permission to add records"}</p>
      )}
      <hr></hr>
      <p></p>
      {rows && columns.length > 0 ? (
        <EmployeeTable
          val={false}
          data={rows}
          columns={columns}
          deleteHandler={deleteHandler}
        />
      ) : (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      )}
    </>
  );
};

export default Misc;
